import { ArticleCard } from "@/components/ArticleCard";
import { CATEGORIES } from "@/lib/api";

export function CategoryTabs({ value, onChange }) {
  const tabs = [{ value: "all", label: "All" }, ...CATEGORIES];
  return (
    <div className="flex flex-wrap gap-2" data-testid="category-tabs">
      {tabs.map((t) => (
        <button
          key={t.value}
          data-testid={`category-tab-${t.value}`}
          onClick={() => onChange(t.value)}
          className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
            value === t.value ? "bg-[var(--chakra)] text-white" : "border border-[var(--line)] bg-white text-stone-700 hover:border-[var(--saffron)] hover:text-[var(--saffron-deep)]"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function ArticlesGrid({ articles, loading, emptyMessage }) {
  if (loading) {
    return (
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="articles-loading">
        {[0, 1, 2].map((i) => <div key={i} className="h-80 animate-pulse rounded-2xl bg-white/80" />)}
      </div>
    );
  }
  if (!articles.length) {
    return (
      <div className="rounded-2xl border border-dashed border-[var(--line)] bg-white/70 p-12 text-center text-stone-500" data-testid="articles-empty">
        {emptyMessage || "No articles here yet. Check back soon."}
      </div>
    );
  }
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="articles-grid">
      {articles.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
    </div>
  );
}
